import { FaWindowMaximize, FaThumbsUp, FaExclamationTriangle, FaMapMarkedAlt } from 'react-icons/fa';

const counter = [
  {
    id: 1,
    icon: <FaWindowMaximize />, // Window Projects icon
    title: 'Window Projects',
    count: '20000',
  },
  {
    id: 2,
    icon: <FaThumbsUp />, // Happy Clients icon
    title: 'Happy Clients',
    count: '30000',
  },
  {
    id: 3,
    icon: <FaExclamationTriangle />, // Emergency Services icon
    title: 'Emergency Services',
    count: '1000',
  },
  {
    id: 4,
    icon: <FaMapMarkedAlt />, // Service Locations icon
    title: 'Service Locations',
    count: '100',
  },
];

export default counter;